<template>
  <AppDialog
    v-model="isDialogOpen"
    header="Get Sequence Access Link"
    style="width: 35rem"
    @click:close="handleClose"
  >
    <div class="flex flex-col gap-4">
      <span class="text-xs text-surface-700"
        >The sequence can be accessed from the link below</span
      >
      <AppInputText
        v-model="sequenceLink"
        :append-icon="copyIcon"
        :is-append-icon-button="true"
        readonly
        @click-append-icon="handleClickCopy"
      />
    </div>

    <template #actions>
      <div class="flex justify-end items-center gap-4 w-full">
        <AppButtonTextSecondary
          label="Close"
          @click="handleConfirm"
        />
      </div>
    </template>
  </AppDialog>
</template>

<script setup lang="ts">
import getFullClientPath from '@/utils/getFullClientPath'
import { useWorkspaceStore } from '@/stores/workspace'

const workspaceStore = useWorkspaceStore()
const router = useRouter()

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  sequenceId: {
    type: String,
    required: true,
  },
})

const emit = defineEmits(['update:modelValue', 'resolve', 'close'])

const isDialogOpen = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emit('update:modelValue', value)
  },
})

const sequenceLink = computed(() => {
  const accessLink = router
    .resolve({
      name: 'sequence-sequenceId',
      params: { sequenceId: props.sequenceId },
      query: { organization: `ws:${workspaceStore.currentWorkspace?.id}` },
    })
    .href.trimStart()

  return getFullClientPath(accessLink)
})

function handleClose() {
  emit('close')
  isDialogOpen.value = false
}

function handleConfirm() {
  emit('resolve')
  isDialogOpen.value = false
}

// COPY LINK ================================================================================================
const copyIcon = ref('fa-regular fa-clone')

async function handleClickCopy() {
  await navigator.clipboard.writeText(sequenceLink.value)
  copyIcon.value = 'fa-regular fa-check'

  setTimeout(() => {
    copyIcon.value = 'fa-regular fa-clone'
  }, 3000)
}
</script>
